import { render, staticRenderFns } from "./BottomMenuCmp.vue?vue&type=template&id=37d7157a&scoped=true&"
import script from "./BottomMenuCmp.vue?vue&type=script&lang=js&"
export * from "./BottomMenuCmp.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenuCmp.vue?vue&type=style&index=0&id=37d7157a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7157a",
  null
  
)

export default component.exports